import React from 'react';
import Modal from 'react-modal';
import MyButton from './MyButton';

Modal.setAppElement('#root');

function MyConfirmationModal({ isOpen, onClose, onConfirm, title, message }) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    border: 'none',
                    background: '#fff',
                    padding: '20px',
                    maxWidth: '400px',
                    width: '90%',
                    textAlign: 'center'
                }
            }}
        >
            <h2>{title}</h2>
            <p>{message}</p>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                <MyButton 
                    text="Cancel" 
                    onClick={onClose}
                    backgroundColor="white"
                    color="#dc3545"
                    hoverBackgroundColor="#f8f8f8"
                    hoverColor="#c82333"
                />
                <MyButton 
                    text="Confirm" 
                    onClick={onConfirm}
                    backgroundColor="#dc3545"
                    color="white"
                    hoverBackgroundColor="#c82333"
                    hoverColor="white"
                />
            </div>
        </Modal>
    );
}

export default MyConfirmationModal;